import { anatomy } from '@shared/tokens/anatomy.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import { typography } from '@shared/tokens/typography.stylex';
import stylex from '@stylexjs/stylex';
export const styles = stylex.create({
  row: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '100%',
    padding: '12px 12px 12px 4px',
    alignSelf: 'stretch',
    ':hover': {
      backgroundColor: colors.brandGhostBackground,
      borderRadius: anatomy.borderRadiusXs,
    },
  },
  disabledRow: {
    opacity: 0.5,
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    width: '100%',
    overflowX: 'visible',
    ':not(#__unused__) > div:last-child': {
      borderBottom: 'none',
    },
  },
  checkbox: {
    paddingTop: '18px',
  },
  vectorIcon: {
    display: 'flex',
    padding: '8px',
    alignItems: 'flex-start',
    gap: '10px',
    alignSelf: 'stretch',
  },

  input: {
    padding: '0 0 16px 0',
  },
  searchInputWrapper: {
    position: 'relative',
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    ':not(#__unused__) > div': {
      width: '100%',
    },
    ':not(#__unused__) input': {
      paddingRight: '40px',
    },
  },
  searchIcon: {
    position: 'absolute',
    right: '16px',
    top: '50%',
    transform: 'translateY(-50%)',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1,
  },
  crossIcon: {
    position: 'absolute',
    right: '16px',
    top: '50%',
    transform: 'translateY(-50%)',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1,
  },
  loader: {
    display: 'flex',
    justifyContent: 'center',
  },
  sendeButtons: {
    paddingBottom: '20px',
  },
  navText: {
    display: 'flex',
    justifyContent: 'space-between',
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-1'],
    fontWeight: typography.fontWeighRegular,
    lineHeight: typography['fontSizeBody-2'],
    color: colors.secondaryText,
  },
  textDelete: {
    display: 'flex',
    alignItems: 'center',
    gap: '5px',
    cursor: 'pointer',
  },
  virtualListContainer: {
    width: '100%',
    overflowX: 'visible',
  },
  virtualScrollContainer: {
    width: '100%',
    height: '600px',
    overflowY: 'auto',
    overflowX: 'hidden',
    position: 'relative',
  },
  virtualInnerContainer: {
    position: 'relative',
    width: '100%',
  },
  virtualRow: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    boxSizing: 'border-box',
    paddingRight: '4px',
    overflowX: 'hidden',
  },
});
